import styles from './AlternateLessonRun.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onStartAlternateLesson: () => void;
};

function AlternateLessonRun(props: Props) {
  const { open, onClose, onStartAlternateLesson } = props;

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <div className={`${styles.header}`}>
          <div className={styles.title}>{'Lesson Instructions'}</div>
        </div>
        <div className={styles.content}>
          <div className={styles.subView}>
            <div className={styles.description}>
              <div className={styles.subheading}>{"To complete this lesson, you will need:"}</div>
              <ul className={styles.boxView}>
                <li className={styles.boxDetail}>
                  {'2 - 4 classes'}
                </li>
                <li className={styles.boxDetail}>
                  {'5 - 10 mins each'}
                </li>
                <li className={styles.boxDetail}>
                  {'One week to complete'}
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.normalText}><strong>Note:</strong>&nbsp;This is a condensed version of the full lesson. We encourage you to use the full lesson if you have 30 - 60 minutes available once/week.</div>
          <div className={styles.action}>
            <Button size="small" className={styles.startButton} onClick={onStartAlternateLesson} label={'Continue'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AlternateLessonRun;
